export default __webpack_public_path__ + "static/media/updateGear.b02307c9.png";